import { render, staticRenderFns } from "./promo-banner.vue?vue&type=template&id=69443dfa&scoped=true"
import script from "./promo-banner.vue?vue&type=script&lang=js"
export * from "./promo-banner.vue?vue&type=script&lang=js"
import style0 from "./promo-banner.vue?vue&type=style&index=0&id=69443dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69443dfa",
  null
  
)

export default component.exports